function isChChar(str?: string) {
    if (!str) return ''
    const reg = /[u4E00-u9FA5uF900-uFA2D]/
    return reg.test(str)
}

function unicode2Ch(t?: string) {
    if (!t) return ''
    for (var e = 1, n = "", i = 0; i < t.length; i += e) {
        e = 1;
        var o = t.charAt(i);
        if ("\\" == o)
            if ("u" == t.charAt(i + 1)) {
                var r = t.substr(i + 2, 4);
                // @ts-ignore
                n += String.fromCharCode(parseInt(r, 16).toString(10)),
                    e = 6
            } else
                n += o;
        else
            n += o
    }
    return n
}

function safeDecodeURIComponent(str: string) {
    try {
        return decodeURIComponent(encodeSearchKey(str))
    } catch(err) {
        console.log(err)
        return str
    }
}

// 对中文编码进行转移
function decodeBTLink(str: string) {
    const link = safeDecodeURIComponent(str)
    if (!isChChar(link)) return link
    return unicode2Ch(link)
}

// 查询关键字中的特殊字符进行编码
function encodeSearchKey(key: string) {
    const encodeArr = [{
        code: '%',
        encode: '%25'
    }, {
        code: '?',
        encode: '%3F'
    }, {
        code: '#',
        encode: '%23'
    }, {
        code: '&',
        encode: '%26'
    }, {
        code: '=',
        encode: '%3D'
    }]

    return key.replace(/[%?#&=]/g, function replaceSpecialCharacter($:string, ..._args:unknown[]) {
        for (const k of encodeArr) {
            if (k.code === $) {
                return k.encode;
            }
        }
        return $
    })
}

export interface IExtractFileInfo {
    url: string
    fileName: string
    fileSize: number
    hash: string
}
function extractFileInfo(link: string) {
    const fileInfo: IExtractFileInfo = { url: link, fileName: link, fileSize: 0, hash: '' }
    // ed2k链接提取文件信息
    if (/ed2k:\/\/\|file\|([^|]+)\|(\d+)\|([a-fA-F\d]{32})\|/.test(link)) {
        const name = RegExp.$1
        const size = RegExp.$2
        const hash = RegExp.$3
        fileInfo.fileName = decodeURIComponent(name)
        fileInfo.fileSize = +size || 0
        fileInfo.hash = hash
    } else if (/ftp:\/\//.test(link)) {
        const name = link.split('/').slice(-1).join('')
        fileInfo.fileName = decodeURIComponent(name)
    } else if (/magnet:/.test(link)) {
        // 解析查询字符串
        const parser = new URLSearchParams(link)
        // 获取文件名和文件大小
        const name = parser.get('dn')
        const size = parser.get('xl')
        fileInfo.fileName = name ? decodeURIComponent(name) : link
        fileInfo.fileSize = size ? +size : 0
    } else if (/https?:\/\//.test(link)) {
        const parser = new URL(link)
        const name = parser.pathname.split('/').slice(-1).join('')
        fileInfo.fileName = decodeURIComponent(name)
    } else if (/\.torrent$/.test(link)) {
        fileInfo.fileName = link.split('/').slice(-1).join('')
    }

    return fileInfo
}

export {
    decodeBTLink,
    extractFileInfo,
}
